import axios from 'src/admin-axios';
import appAxios from 'src/app-axios';
import Constants from 'src/constants';

export const users = {
    namespaced: true,
    state: {
        usersList: [],
        usersSignUpList: [],
        countryCodes: {},
        timeZones: {},
    },
    getters: {
        getUsersList (state) {
            return state.usersList;
        },
        getUsersSignUpList (state) {
            return state.usersSignUpList;
        },
        getCountryCodes (state) {
            return state.countryCodes;
        },
        getTimeZones (state) {
            return state.timeZones;
        },
    },
    mutations: {
        setUsersList (state, data) {
            state.usersList = data;
        },
        setUsersSignUpList (state, data) {
            state.usersSignUpList = data;
        },
        setCountryCodes (state, data) {
            state.countryCodes = data;
        },
        setTimeZones (state, details) {
            state.timeZones = details;
        },
    },
    actions: {
        async fetchUsersList ({ dispatch, commit }) {
            const url = '/users';
            try {
                const details = await axios.get(url);
                commit('setUsersList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting users list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createUser ({ dispatch }, payload) {
            const url = '/users';
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating a new user.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async deleteUser ({ dispatch }, userId) {
            const url = `/users/${userId}`;
            try {
                await axios.delete(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting the user.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchUsersListByOrganization ({ dispatch, commit }, id) {
            const url = `/organizations/${id}/users`;
            try {
                const details = await axios.get(url);
                commit('setUsersList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting users list based on organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchUsersSignUpList ({ dispatch, commit }, { params }) {
            const url = 'users/sign-up';
            try {
                const details = await axios.get(url, { params: params });
                commit('setUsersSignUpList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: ' Something went wrong in getting the users sign up list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updateUserRole ({ dispatch }, payload) {
            const url = 'api/user-admin/users/roles';
            try {
                await appAxios.put(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating role.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchCountryCodes ({ dispatch, commit }) {
            const url = '/country-codes';
            try {
                const details = await axios.get(url);
                commit('setCountryCodes', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting country zip code.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchTimeZones ({ dispatch, commit }) {
            const url = '/timezones';
            try {
                const details = await axios.get(url);
                commit('setTimeZones', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting TimeZone.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
    },
};
